export { ManagementFee, type Props } from './index.pc'
export { MobileManagementFee } from './index.mobile'
